import {useTranslation} from "react-i18next";
import {useState} from "react";
import DBModal from "../../../../../component/global/DBModal";
import {ReactComponent as Gift} from "../../../../../asset/icons/giftIcon.svg";
import BackButton from "../../../../../component/global/BackButton";
import {Tab, Tabs} from "react-bootstrap";
import BuyVolume from "./BuyVolume";

function PackagesBuyVolumeModal(props) {
  const {onHide, show} = props
  const {t} = useTranslation()
  const [activeTab, setActiveTab] = useState('1')

  return (
    <DBModal
      minWidth={300}
      show={show}
      onHide={onHide}
      className="packages-buy-volume-modal"
    >
      <DBModal.Content>
        <div className='header-modal'>
          <div className='logo'>
            <Gift/>
            <span>{t('Organizational.Profile.Packages.Buy.Volume.Title')}</span>
          </div>
          <BackButton onclickFunction={onHide}/>
        </div>
        <div className="content-modal">
          <div className='tab-section'>
            <Tabs
              activeKey={activeTab}
              transition={false}
              className="panel_tab"
              onSelect={(tab) => setActiveTab(tab)}
            >
              <Tab
                eventKey="1"
                className="panel_tab_item"
                title={t('Organizational.Profile.Packages.Buy.Volume.Packages.Tab')}
              />
            </Tabs>
          </div>
          <div className="content-section">
            {activeTab === "1" && <BuyVolume/>}
          </div>
        </div>
      </DBModal.Content>
    </DBModal>
  );
}

export default PackagesBuyVolumeModal;
